export type Tone = 'ok' | 'watch' | 'crit';

// Literal Tailwind arbitrary-value classes (not string-interpolated) so the JIT compiler's
// static source scan picks them up at build time — swapping these for a runtime
// `style={{ backgroundColor }}` is what the illustration mocks used to do, which put a raw
// `style` attribute in every rendered row and tripped SEO audits' "remove inline styles" check.
export const TONE_DOT_CLASS: Record<Tone, string> = {
  ok: 'bg-[#3ddc84]',
  watch: 'bg-[#e0a62a]',
  crit: 'bg-[#e05a5a]',
};

// The three-dot "browser chrome" traffic light used by Hero's preview panel and every
// IllustrationFrame mock.
export const TRAFFIC_LIGHT_DOT_CLASSES = ['bg-[#e05a5a]', 'bg-[#e0a62a]', 'bg-[#3ddc84]'];
